import React, { useState, useCallback, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import Switch from 'react-switch'

import { Collapse } from '@material-ui/core'
import usePersistedState from '../../hooks/usePersistedState'

import Button from '../../components/Button'
import Header from '../../components/Header'

import { UserDetails, Participant } from '../../utils/interfaces'
import {
  Container,
  Content,
  InvestorBox,
  GoalItem,
  BtnVoltar,
  Line,
} from './styles'
import ModalBox from '../../components/Modal'

const Investor: React.FC = () => {
  const [participants] = usePersistedState<Participant[]>(
    'participantsGroup',
    [],
  )
  const [userDetails, setUserDetails] = usePersistedState<UserDetails>(
    'userDetails',
    {} as UserDetails,
  )

  const history = useHistory()

  // const [selectedQuiz] = usePersistedState<>(userDetails.investor)
  const [selected, setSelected] = useState(userDetails.investor)
  const [selectedQuiz, setSelectedQuiz] = usePersistedState<string>(
    'selectedQuiz',
    '',
  )
  const [dcrSelected, setDcrSelected] = usePersistedState<string>(
    'dcrSelected',
    '',
  )
  const [dcrSelectedQuiz, setDcrSelectedQuiz] = usePersistedState<string>(
    'dcrSelectedQuiz',
    '',
  )
  const [descrInvest, setDescInvest] = useState('')
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [textoModal, setTextoModal] = useState('')
  const [acceptInvestor, setAcceptInvestor] = usePersistedState<boolean>(
    'acceptInvestor',
    false,
  )

  function handleCloseModal(): void {
    setIsModalOpen(false)
  }

  const handleInvestItem = useCallback(valor => {
    if (valor === 'CON') {
      setSelected(valor)
      setDescInvest(
        `Uma parte do saldo (de 3 a 7% do total) poderá ser aplicado em renda variável
          (ações em bolsa de valores, por exemplo). Essa parte do dinheiro poderá ter ganhos
          ou perdas maiores.`,
      )
      setDcrSelected('conservador')
    } else if (valor === 'MOD') {
      setSelected(valor)
      setDescInvest(
        `Uma parte do saldo (de 12 a 18% do total) poderá ser aplicado em renda variável
          (ações em bolsa de valores, por exemplo). Essa parte do dinheiro poderá ter ganhos
          ou perdas maiores.`,
      )
      setDcrSelected('moderado')
    } else if (valor === 'AGR') {
      setSelected(valor)
      setDescInvest(
        `Uma parte do saldo (de 25 a 35% do total) poderá ser aplicado em renda variável
          (ações em bolsa de valores, por exemplo). Essa parte do dinheiro poderá ter ganhos
          ou perdas maiores. A rentabilidade é menos previsível.`,
      )
      setDcrSelected('agressivo')
    }
  }, [])

  useEffect(() => {
    handleInvestItem(selected)
  }, [handleInvestItem, selected])

  const handleContinue = useCallback(async () => {
    if (selected === '') {
      setIsModalOpen(true)
      setTextoModal('Informe seu perfil de investidor')
    } else {
      await setUserDetails({
        ...userDetails,
        investor: selected,
      })
      participants.length > 0
        ? history.push('/participants-list')
        : history.push('/new-participant')
    }
  }, [history, participants, selected, setUserDetails, userDetails])

  const toggleAcceptInvestor = useCallback(() => {
    setAcceptInvestor(!acceptInvestor)
  }, [acceptInvestor, setAcceptInvestor])

  return (
    <>
      <Header />
      <ModalBox isOpen={isModalOpen} onRequestClose={handleCloseModal}>
        {textoModal}
      </ModalBox>
      <Container>
        <Content>
          <strong>Perfil de Investimento: </strong>
          <p>
            Agora que você já respondeu o questionário, escolha abaixo qual o
            perfil de investimento que você deseja:
          </p>

          <InvestorBox>
            {/* <GoalItem
              key="1"
              isSelected={selected === 'S'}
              onClick={() => handleInvestItem('S')}
            >
              <span>Superconservador</span>
            </GoalItem> */}
            <GoalItem
              key="2"
              isSelected={selected === 'CON'}
              onClick={() => handleInvestItem('CON')}
            >
              <span>Conservador</span>
            </GoalItem>
            <GoalItem
              key="3"
              isSelected={selected === 'MOD'}
              onClick={() => handleInvestItem('MOD')}
            >
              <span>Moderado</span>
            </GoalItem>
            <GoalItem
              key="4"
              isSelected={selected === 'AGR'}
              onClick={() => handleInvestItem('AGR')}
            >
              <span>Agressivo</span>
            </GoalItem>
          </InvestorBox>

          <Line />
          {/* <footer>
            <p>{descrInvest}</p>
          </footer> */}
          <Collapse in={selectedQuiz !== selected}>
            <div className="switch">
              <small>
                {`Estou ciente que o perfil de investimento escolhido (${dcrSelected}) não está adequado ao meu perfil (${dcrSelectedQuiz}).`}
              </small>
              <Switch
                onChange={toggleAcceptInvestor}
                checked={acceptInvestor}
                checkedIcon={false}
                uncheckedIcon={false}
                height={20}
                width={40}
                handleDiameter={16}
                offColor="#DEE3E1"
                offHandleColor="#fff"
                onHandleColor="#fff"
                onColor="#31D19E"
              />
            </div>
          </Collapse>
        </Content>
        <Button
          type="button"
          color="orange"
          onClick={handleContinue}
          disabled={!selected || (selectedQuiz !== selected && !acceptInvestor)}
        >
          Continuar
        </Button>
        <BtnVoltar type="button" onClick={() => history.push('/investor-quiz')}>
          &lt; Anterior
        </BtnVoltar>
      </Container>
    </>
  )
}

export default Investor
